<div class="{{ classList }} aux-editable-list-dropdown">
  @if (label) {
    <span class="mb-1 block text-sm">
      {{ label }}
    </span>
  }

  <ng-select
    #dropdown
    bindValue="value"
    bindLabel="name"
    placeholder="Select a Curve"
    dropdownPosition="bottom"
    class="editable-list-select text-sm"
    [id]="id"
    [clearable]="false"
    [searchable]="false"
    [(ngModel)]="formControlValue"
  >
    @for (item of items; track item; let index = $index; let first = $first) {
      <ng-option [value]="item.value">
        {{ item.name }}
      </ng-option>
    }

    <ng-template ng-label-tmp let-value="item">
      <div
        #label
        class="truncate"
        [auxTooltip]="label.offsetWidth < label.scrollWidth ? getLabelText(value) : ''"
      >
        {{ getLabelText(value) }}
      </div>
    </ng-template>

    <ng-template ng-footer-tmp class="flex flex-col">
      <div class="items-wrapper grow">
        @for (item of items; track item; let index = $index; let first = $first) {
          <ng-option>
            @if (item.showLine && !first) {
              <div class="mb-2 ml-2 mr-2 mt-1 h-1 border-b border-aux-gray-darkest"></div>
            }

            <div
              class="relative flex cursor-default select-none justify-between py-2 pl-2 text-gray-900 hover:bg-aux-gray-light"
              (click)="select(item.value); dropdown.close()"
            >
              <div class="flex flex-1 flex-col justify-center truncate">
                <p
                  #optionName
                  class="truncate"
                  [auxTooltip]="optionName.offsetWidth < optionName.scrollWidth ? item.name : ''"
                >
                  {{ item.name }}
                </p>
                @if (item.bottomText) {
                  <p
                    #optionBottomText
                    class="mt-1 truncate text-xxs"
                    [auxTooltip]="
                      optionBottomText.offsetWidth < optionBottomText.scrollWidth
                        ? item.bottomText || ''
                        : ''
                    "
                  >
                    {{ item.bottomText }}
                  </p>
                }
              </div>

              <div class="ml-2 flex">
                @if (item.isEditable) {
                  <button
                    class="mr-1 text-aux-blue-dark"
                    [ngClass]="{ 'cursor-not-allowed opacity-50': item.disabled || editDisabled() }"
                    (click)="onEdit($event, item); dropdown.close()"
                    [auxTooltip]="createDisabledTooltip()"
                  >
                    <aux-icon name="Pencil" [title]="item.tooltip || ''" />
                  </button>
                }

                @if (item.isDeletable) {
                  <button class="text-aux-red-hover">
                    <aux-icon
                      name="Trash"
                      [ngClass]="{
                        'cursor-not-allowed opacity-50': item.disabled || deleteDisabled(),
                      }"
                      (click)="onDelete($event, item); dropdown.close()"
                      [title]="item.tooltip || ''"
                      [auxTooltip]="createDisabledTooltip()"
                    />
                  </button>
                }
              </div>
            </div>
          </ng-option>
        }
      </div>

      <div class="sticky bottom-0 bg-white pb-1">
        @if (createBtnLabel && items.length) {
          <div class="ml-2 mr-2 mt-1 h-1 border-b border-aux-gray-darkest"></div>
        }

        @if (createBtnLabel) {
          <div class="btn--hyperlink my-2 pl-2">
            <span
              (click)="onCreate(); dropdown.close()"
              [ngClass]="{
                'cursor-not-allowed opacity-50': createDisabled(),
                'cursor-pointer': !createDisabled(),
              }"
              [auxTooltip]="createDisabledTooltip()"
            >
              + {{ createBtnLabel }}
            </span>
          </div>
        }
      </div>
    </ng-template>
  </ng-select>
</div>
